import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { API_URL, useAxios } from "../../../../../utils/const";
import { Controller, useForm } from "react-hook-form";
import { useToast } from "../../../../../Context/ToastContext";

const CreateModal = ({
  toggleModal,
  id,
  ids,
  getCourseLecturers,
  getCourseStudents,
  course_type,
}) => {

  const axiosInstance = useAxios();
  const { setToastObj } = useToast();

  const { control, handleSubmit, register, setValue } = useForm({
    defaultValues: {
      nama: [],
    },
  });

  const [lecturerOptions, setLecturerOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const getUsers = async () => {
    const response = await axiosInstance.get(
      `${API_URL}/course-lecturers/course-group/${id}`
    );

    const filteredUsers = response.data.data.map((u) => ({
      value: u.lecturer.id,
      label: u.lecturer.name,
    }));

    setLecturerOptions(filteredUsers);
  };

  const handleSave = async (formData) => {
    setLoading(true);
    try {
      const data = {
        lecturers: formData.lecturer.map((lecturer) => ({
          lecturer_id: lecturer.value,
        })),
        check_in: formData.check_in,
      };

      await axiosInstance.put(
        `${API_URL}/course-attendances/lecturer/add-participant/${ids}/${course_type}`,
        data
      );

      getCourseLecturers();
      getCourseStudents();
      setToastObj({ msg: "Data Berhasil ditambahkan", type: "success" });
      setLoading(false);
      toggleModal(false);
    } catch (error) {
      let errorMessage = "Terjadi kesalahan";
      if (error.response.data.msg != undefined) {
        errorMessage = `Terjadi kesalahan, ${error.response.data.msg}`;
      } else {
        errorMessage = error.message;
      }
      setLoading(false);
      setToastObj({
        msg: errorMessage,
        type: "danger",
      });
      closeModal();
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getCurrentTime();
        await getUsers();
      } catch (error) {
        setToastObj({
          msg: error,
          type: "danger",
        });
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const closeModal = () => {
    toggleModal(false);
  };

  const getCurrentTime = async () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0'); // Add leading zero if needed
    const minutes = String(now.getMinutes()).padStart(2, '0'); // Add leading zero if needed
    setValue("check_in", `${hours}:${minutes}`);
  }

  return loading === false ? (
    <Modal show={toggleModal} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h6>Tambah Kehadiran</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group mb-3">
          <label className="form-label">Nama</label>
          <Controller
            name="lecturer"
            control={control}
            render={({ field }) => (
              <Select
                {...field}
                isMulti
                options={lecturerOptions}
                onChange={(selected) => field.onChange(selected)}
              />
            )}
          />
        </div>

        <div className="form-group mb-3">
          <label className="form-label">Waktu Hadir</label>
          <input
            {...register("check_in")}
            type="time"
            className="form-control"
          />
        </div>
        <button
          className="btn w-100 btn-success"
          onClick={handleSubmit(handleSave)}
        >
          Tambah
        </button>
      </Modal.Body>
    </Modal>
  ) : (
    <div>
      <div className="row">
        <div
          className="col-md-12 text-center align-center"
          style={{ marginTop: "20%" }}
        >
          <h1>Mohon Tunggu</h1>
        </div>
      </div>
    </div>
  );
};

export default CreateModal;
